// Campo de data com hora OPCIONAL — no lugar do <input type="datetime-local">,
// que salva VAZIO quando a pessoa escolhe só o dia (ver utils/campoDataHora.ts).
// Funciona solto (value/onChange) e dentro de <Form.Item name=…> do antd.
import { useState } from 'react';
import { Input, Space } from 'antd';
import { partesDaDataHora, juntarDataHora } from '../utils/campoDataHora';

interface Props {
  /** "AAAA-MM-DDTHH:mm" ou '' — o mesmo formato do datetime-local. */
  value?: string | null;
  onChange?: (valor: string) => void;
  disabled?: boolean;
}

export default function CampoDataHora({ value, onChange, disabled }: Props) {
  const partes = partesDaDataHora(value);
  // Hora digitada antes do dia: guardada até o dia chegar (sem dia não há valor).
  const [horaSolta, setHoraSolta] = useState('');
  const hora = partes.data ? partes.hora : horaSolta;
  return (
    <Space.Compact style={{ width: '100%', maxWidth: 340 }}>
      <Input type="date" aria-label="Data" value={partes.data} disabled={disabled} style={{ flex: '3 1 0' }}
        onChange={(e) => onChange?.(juntarDataHora(e.target.value, hora))} />
      <Input type="time" aria-label="Hora (opcional)" title="Hora (opcional): sem hora, vale o dia todo"
        value={hora} disabled={disabled} style={{ flex: '2 1 0' }}
        onChange={(e) => { setHoraSolta(e.target.value); onChange?.(juntarDataHora(partes.data, e.target.value)); }} />
    </Space.Compact>
  );
}
